const API_BASE = process.env.REACT_APP_API_BASE;

async function safeJson(res) {
  // ✅ Try JSON first no matter what headers say
  try {
    return await res.json();
  } catch {
    const text = await res.text().catch(() => "");
    return { message: text };
  }
}

export async function startProductCheckout(priceId, options = {}) {
  const { color = "black", quantity = 1 } = options;

  const controller = new AbortController();
  const t = setTimeout(() => controller.abort(), 12000);

  let res;
  try {
    res = await fetch(`${API_BASE}/store/checkout`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ priceId, quantity, color }),
      signal: controller.signal,
    });
  } catch (e) {
    if (e.name === "AbortError") {
      return { ok: false, message: "Checkout is taking longer than expected. Please try again." };
    }
    return { ok: false, message: "Network error starting checkout. Please try again." };
  } finally {
    clearTimeout(t);
  }

  const data = await safeJson(res);

  if (res.status === 409) {
    return { ok: false, outOfStock: true, message: data.message || "Out of stock." };
  }

  if (!res.ok) {
    console.error("Product checkout error:", res.status, data);
    return { ok: false, message: data?.message || data?.details || "Checkout failed." };
  }

  if (!data?.url) {
    console.error("Checkout response missing url:", data);
    return { ok: false, message: "No checkout URL returned from backend." };
  }

  return { ok: true, url: data.url };
}

export async function fetchOrderStatus(sessionId) {
  if (!sessionId) throw new Error("Missing session_id");

  const res = await fetch(
    `${API_BASE}/store/order-status?session_id=${encodeURIComponent(sessionId)}`,
    { method: "GET" }
  );

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    console.error("Order status error:", res.status, text);
    throw new Error("Failed to load order status");
  }

  return res.json();
}
